import gql from "graphql-tag";

export function mapArea(area_uni) {
    if (area_uni === 1) {
        return 1;
    } else if (area_uni === 3) {
        return 4;
    } else if (area_uni === 5) {
        return 6;
    } else if (area_uni === 6) {
        return 10;
    } else if (area_uni === 7) {
        return 12;
    } else if (area_uni === 8) {
        return 62;
    } else if (area_uni === 9) {
        return 64;
    } else if (area_uni === 10) {
        return 66;
    } else if (area_uni === 11) {
        return 70;
    } else if (area_uni === 12) {
        return 72;
    }
    return -1;
}

export function mapCategoria(cate_uni) {
    if (cate_uni === 1) {
        return 1;
    } else if (cate_uni === 2) {
        return 2;
    } else if (cate_uni === 3) {
        return 3;
    } else if (cate_uni === 4) {
        return 24;
    } else if (cate_uni === 5) {
        return 26;
    }
    return -1;
}


export const getPosgrado = async (thiz, id) => {
    let sql = gql`query{ getPostgrado(id:${id}){id,nombre,categoria{nombre},portada,objetivo,dirigido} }`;
    let res = await thiz.$apollo.query({query: sql}).then(({data}) =>data).catch(e=>e);
    // window.console.log('---->', res);
    if(res && res.getPostgrado){
        return res.getPostgrado;
    }
    return res;
}

export const criterios_rechazo_esam = () => {
    const c = [
        'CHOQUE DE SEGMENTO',
        'PROGRAMA NO APROBADO',
        'EQUIPO INSUFICIENTE',
        'EXCESO DE PROGRAMAS EN ARRASTRE'
    ]
    return c
}